"use strict";

function Iteminview($el, options) {
  this.element = $el;
  this.callback = options.callback;
  this.inview = false;
  this.initialize();
}
Iteminview.prototype.initialize = function () {
  var self = this;
  this.windowHeight = window.innerHeight;
  this.checkPosition();
  this.addEventHandlers();
};
Iteminview.prototype.addEventHandlers = function () {
  var self = this;
  window.addEventListener("scroll", function () {
    self.checkPosition();
  });
  window.addEventListener("DOMMouseScroll", function () {
    self.checkPosition();
  });
};
Iteminview.prototype.checkPosition = function () {
  var self = this;
  var posFromTop = self.element.getBoundingClientRect().top;
  var $item = self.element;
  if (posFromTop - this.windowHeight <= -50) {
    var delay = 100;
    if (window.scrollY == 0) {
      delay = 400;
    }
    setTimeout(function () {
      $item.classList.add('inview');
      self.inview = true;
      self.callback(true);
    }, delay);
  } else {
    self.inview = false;
    self.callback();
    if ($item.classList.contains('repeat')) {
      setTimeout(function () {
        $item.classList.remove('inview');
      }, 100);
    }
  }
};
window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();
function Sjkroll($el, options) {
  this.element = $el;
  this.part = options.part;
  this.breakpoint = options.breakpoint;
  this.direction = options.direction;
  this.speed = options.speed;
  this.initialize();
}
Sjkroll.prototype.initialize = function () {
  var self = this;
  this.windowHeight = window.innerHeight;
  this.checkPosition();
  this.addEventHandlers();
};
Sjkroll.prototype.addEventHandlers = function () {
  var self = this;
  window.addEventListener("scroll", function () {
    this.animFrame = requestAnimFrame(() => {
      self.checkPosition();
    });
  });
  window.addEventListener("DOMMouseScroll", function () {
    self.checkPosition();
  });
};
Sjkroll.prototype.checkPosition = function () {
  var self = this;
  var posFromTop = this.element.getBoundingClientRect().top;
  if (posFromTop - this.windowHeight <= -50) {
    if (this.breakpoint !== undefined && window.innerWidth < this.breakpoint) {
      self.part.style.transform = '';
    } else {
      if (self.direction == 'vertical') {
        self.part.style.transform = 'translateY(' + parseInt(posFromTop / self.speed - self.speed) + 'px)';
      }
      if (self.direction == 'verticalReverse') {
        self.part.style.transform = 'translateY(' + parseInt(-posFromTop / 10 + 10) + 'px)';
      }
    }
  }
};
var settings;
var i;
var cookieBar;
var cookieOverlay;
var cookies = {};
var feedUrl = '/json/nde-cookies-nl.json';
var newLocalCookiesArr = [];
var externalButton = document.getElementById('open-cookie-settings');
if (externalButton !== null) {
  externalButton.onclick = function (e) {
    e.preventDefault();
    fetch(getFeedUrlFromDomain(), {}).then(function (response) {
      return response.json();
    }).then(function (myJson) {
      data = myJson;
      createCookieOverlay(data);
      openPreferences('all');
    }).catch(function () {
      console.log('cookie data could not be retreived');
    });
  };
}

// console.log(window.location.hostname);

function getFeedUrlFromDomain() {
  var subfolder = window.location.pathname.replace(/^\/([^\/]*).*$/, '$1');
  if (subfolder == 'en') {
    feedUrl = '/wp-content/themes/nde_2020/assets/json/nde-cookies-en.json';
  } else {
    feedUrl = '/wp-content/themes/nde_2020/assets/json/nde-cookies-nl.json';
  }
  return feedUrl;
}
getFeedUrlFromDomain();

// -----------------------------------------------------------------
// basic checkers and setters for cookies
// -----------------------------------------------------------------

function get_cookies_array() {
  var cookies = {};
  if (document.cookie && document.cookie != '') {
    var split = document.cookie.split(';');
    for (var i = 0; i < split.length; i++) {
      var name_value = split[i].split("=");
      name_value[0] = name_value[0].replace(/^ /, '');
      cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(name_value[1]);
    }
  }
  return cookies;
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function checkCookie(name) {
  var cookie = getCookie(name);
  if (cookie != "") {
    return true;
  } else {
    return false;
  }
}

// first of all check if the user has made a choice yet, only continue when false
if (checkCookie('cookie_choices_set') == false) {
  if (checkCookie('user_cookies') == false) {
    compareAndSet(get_cookies_array());
    function compareAndSet(localCookies) {
      fetch(getFeedUrlFromDomain(), {
        // method: 'post', 
        // headers: new Headers({
        //     'Authorization': 'Basic '+btoa('silo:givemecookies'), 
        //     'Content-Type': 'application/x-www-form-urlencoded'
        // }) 
      }).then(function (response) {
        return response.json();
      }).then(function (myJson) {
        data = myJson;
        compareCookies(data, localCookies);
      }).catch(function () {
        console.log('cookie data could not be retreived');
      });
      function compareCookies(data, localCookies) {
        // create a new object for storing the final settings in a cookie
        for (var i = 0; i < data.options.length; i++) {
          var properties = data.options[i].properties;
          newLocalCookiesArr.push({
            'category': data.options[i].slug,
            'active': true
          });
          newLocalCookiesArr[i].properties = [];
          for (var n = 0; n < properties.length; n++) {
            var checkName = properties[n].name;
            if (localCookies.hasOwnProperty(checkName) !== undefined) {
              var item = {
                'name': checkName,
                'value': localCookies[checkName],
                'days_stored': properties[n].days_stored,
                'category': data.options[i].slug
              };
              newLocalCookiesArr[i].properties.push(item);
            } else {
              console.log('there are cookies in the feed that do not exist locally');
            }
            // remove from the localCookies array so we can check if all were set
            delete localCookies[checkName];
          }
        }
        if (Object.keys(localCookies).length != 0) {
          // report if there are missing properties!
          // console.log('Cookie message has missing properties: ' + Object.keys(localCookies));
        }
        setCookie('user_cookies', JSON.stringify(newLocalCookiesArr), 365);
        createCookieBar(data, newLocalCookiesArr);
        createCookieOverlay(data, newLocalCookiesArr);
      }
      ;
    }
  } else {
    fetch(getFeedUrlFromDomain(), {
      // method: 'post', 
      // headers: new Headers({
      //     'Authorization': 'Basic '+btoa('silo:givemecookies'), 
      //     'Content-Type': 'application/x-www-form-urlencoded'
      // }) 
    }).then(function (response) {
      return response.json();
    }).then(function (myJson) {
      data = myJson;
      createCookieBar(data);
      createCookieOverlay(data);
    }).catch(function () {
      console.log('cookiebar data could not be retreived');
    });
  }
}

// these below are just tester functions to be removed in final deployment
// console.log(getCookie('user_cookies'));
// document.cookie = "user_cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

function createCookieBar(settings) {
  // create bar
  cookieBar = document.createElement('div');
  cookieBar.setAttribute("id", "cookie-bar");
  cookieBar.classList.add('p-all-half-space');

  // create message
  var message = document.createElement('div');
  message.classList.add('message');

  // -- create settings icon 
  var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg'); //Get svg element
  svg.classList.add('icon', 'icon-cog');
  svg.setAttribute('viewBox', '0 0 32 32');
  var pathOne = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathOne.setAttribute("d", "M19.465 20.593l1.396-1.396 6.274 6.274-1.396 1.396-6.274-6.274z"); //Set path's data
  var pathTwo = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathTwo.setAttribute("d", "M5.413 6.541l1.396-1.396 6.274 6.274-1.396 1.396-6.274-6.274z"); //Set path's data
  var pathThree = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathThree.setAttribute("d", "M17.465 10.546l3.396-8.198 1.824 0.755-3.396 8.198-1.824-0.755z"); //Set path's data
  var pathFour = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathFour.setAttribute("d", "M9.861 28.908l3.396-8.198 1.824 0.755-3.396 8.198-1.824-0.755z"); //Set path's data
  var pathFive = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathFive.setAttribute("d", "M15.286 21.507h1.974v8.873h-1.974v-8.873z"); //Set path's data
  var pathSix = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathSix.setAttribute("d", "M15.286 1.62h1.974v8.873h-1.974v-8.873z"); //Set path's data
  var pathSeven = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathSeven.setAttribute("d", "M17.467 21.468l1.824-0.755 3.396 8.198-1.824 0.755-3.396-8.198z"); //Set path's data
  var pathEight = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathEight.setAttribute("d", "M9.863 3.107l1.824-0.755 3.396 8.198-1.824 0.755-3.396-8.198z"); //Set path's data
  var pathNine = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathNine.setAttribute("d", "M2.619 11.42l0.755-1.824 8.198 3.396-0.755 1.824-8.198-3.396z"); //Set path's data
  var pathTen = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathTen.setAttribute("d", "M20.976 12.991l8.198-3.396 0.755 1.824-8.198 3.396-0.755-1.824z"); //Set path's data
  var pathEleven = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathEleven.setAttribute("d", "M2.619 20.597l8.198-3.395 0.755 1.824-8.198 3.395-0.755-1.824z"); //Set path's data
  var pathTwelve = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathTwelve.setAttribute("d", "M19.465 11.421l6.274-6.274 1.396 1.396-6.274 6.274-1.396-1.396z"); //Set path's data
  var pathThirteen = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathThirteen.setAttribute("d", "M5.413 25.474l6.274-6.274 1.396 1.396-6.274 6.274-1.396-1.396z"); //Set path's data
  var pathFourteen = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
  pathFourteen.setAttribute("d", "M1.901 15.020h28.745v1.974h-28.745v-1.974z"); //Set path's data
  svg.appendChild(pathOne);
  svg.appendChild(pathTwo);
  svg.appendChild(pathThree);
  svg.appendChild(pathFour);
  svg.appendChild(pathFive);
  svg.appendChild(pathSix);
  svg.appendChild(pathSeven);
  svg.appendChild(pathEight);
  svg.appendChild(pathNine);
  svg.appendChild(pathTen);
  svg.appendChild(pathEleven);
  svg.appendChild(pathTwelve);
  svg.appendChild(pathThirteen);
  svg.appendChild(pathFourteen);
  message.appendChild(svg);
  svg.onclick = function () {
    openPreferences();
  };

  // -- create text div
  var textDiv = document.createElement('div');
  textDiv.classList.add('text');

  // -- -- create h2
  var textDivH2 = document.createElement('h2');
  var barTitle = document.createTextNode(settings.cookieBar.title);
  textDivH2.appendChild(barTitle);
  textDiv.appendChild(textDivH2);

  // -- -- create p
  var textDivP = document.createElement('p');
  // var barText = document.createTextNode(settings.cookieBar.description);
  textDivP.innerHTML = settings.cookieBar.description;
  textDiv.appendChild(textDivP);

  // add text div to message
  message.appendChild(textDiv);

  // add message to bar
  cookieBar.appendChild(message);

  // create actions div
  var actionsDiv = document.createElement('div');
  actionsDiv.classList.add('actions');

  // -- create button accept
  var acceptButton = document.createElement('button');
  acceptButton.classList.add('btn', 'btn-highlight');
  acceptButtonLabel = document.createTextNode(settings.cookieBar.acceptButtonLabel);
  acceptButton.appendChild(acceptButtonLabel);
  actionsDiv.appendChild(acceptButton);
  acceptButton.onclick = function (e) {
    e.preventDefault();
    acceptCookies(settings.options);
  };

  // -- create button preferences
  var preferenceButton = document.createElement('button');
  preferenceButton.classList.add('btn');
  preferenceButtonLabel = document.createTextNode(settings.cookieBar.settingsButtonLabel);
  preferenceButton.appendChild(preferenceButtonLabel);
  actionsDiv.appendChild(preferenceButton);
  preferenceButton.onclick = function (e) {
    e.preventDefault();
    openPreferences('all');
  };

  // -- create the close settings button
  var barCloseButton = document.createElement('button');
  barCloseButton.classList.add('cookie-close-button');
  barCloseButton.innerHTML = '<div class="bar"></div><div class="bar"></div>';
  actionsDiv.appendChild(barCloseButton);
  barCloseButton.onclick = function () {
    closeCookieBar();
  };

  // add actions to bar
  cookieBar.appendChild(actionsDiv);

  // add bar to body
  document.body.insertBefore(cookieBar, document.body.firstChild);
  setTimeout(function () {
    // make the bar visible
    cookieBar.classList.add('open');
  }, 1000);
}
function createCookieOverlay(settings) {
  // create the cookie overlay
  cookieOverlay = document.createElement('div');
  cookieOverlay.setAttribute('id', 'cookie-overlay');

  // create cookie settings div
  var settingsDiv = document.createElement('div');
  settingsDiv.classList.add('cookie-settings');

  // -- create settings holder (so we can scroll in this baby)
  var settingsHolderDiv = document.createElement('div');
  settingsHolderDiv.classList.add('settings-holder', 'p-all-half-space');

  // -- create the close settings button
  var settingsCloseButton = document.createElement('div');
  settingsCloseButton.classList.add('cookie-close-button');
  settingsCloseButton.innerHTML = '<div class="bar"></div><div class="bar"></div>';
  settingsCloseButton.onclick = function () {
    closePreferences(settings.options);
  };

  // -- create the settings title
  var settingsH2 = document.createElement('h2');
  var settingsTitle = document.createTextNode(settings.cookieOverlay.title);
  settingsH2.appendChild(settingsTitle);
  settingsHolderDiv.appendChild(settingsH2);

  // -- create the settings text
  var settingsP = document.createElement('p');
  // var settingsText = document.createTextNode(settings.cookieOverlay.description);
  // settingsP.appendChild(settingsText);
  settingsP.innerHTML = settings.cookieOverlay.description;
  settingsHolderDiv.appendChild(settingsP);

  // -- create accept settings button
  var acceptButton = document.createElement('a');
  acceptButton.classList.add('btn', 'btn-highlight');
  acceptButtonLabel = document.createTextNode(settings.cookieOverlay.acceptButtonLabel);
  acceptButton.appendChild(acceptButtonLabel);
  settingsHolderDiv.appendChild(acceptButton);
  acceptButton.onclick = function () {
    acceptCookies(settings.options);
  };

  // -- create cookie options list
  var optionsUl = document.createElement('ul');
  optionsUl.classList.add('cookie-options', 'm-t-half-space');

  // -- -- create cookie options list items
  for (var i = 0; i < settings.options.length; i++) {
    var li = document.createElement("li");
    li.classList.add("p-t-half-space", "p-b-half-space");
    optionsUl.appendChild(li);

    // -- -- -- create list header
    var optionHeader = document.createElement('header');

    // -- -- -- -- create list item title
    var optionH2 = document.createElement('h3');
    var optionTitle = document.createTextNode(settings.options[i].title);
    optionH2.appendChild(optionTitle);
    optionHeader.appendChild(optionH2);

    // -- -- -- -- create list item button 
    var optionToggler = document.createElement('a');
    togglerLabel = document.createTextNode('on');
    optionToggler.appendChild(togglerLabel);
    optionToggler.classList.add('switch');
    existingOptions = JSON.parse(getCookie('user_cookies'));
    if (existingOptions !== undefined) {
      existingOptions[i].active ? optionToggler.classList.add('on') : '';
    } else {
      settings.options[i].active ? optionToggler.classList.add('on') : '';
    }
    optionHeader.appendChild(optionToggler);

    // create option warning

    var id = i;
    var toggleOptions;
    var hasSwitch = settings.options[i].switch;
    if (hasSwitch) {
      optionToggler.onclick = function (id, toggleOptions) {
        return function (e) {
          if (toggleOptions[id].warning == undefined) {
            if (toggleOptions[id].active) {
              toggleOptions[id].active = false;
              e.target.classList.remove('on');
            } else {
              toggleOptions[id].active = true;
              e.target.classList.add('on');
            }
          } else {
            if (e.target.classList.contains('on')) {
              e.target.classList.remove('on');
            } else {
              e.target.classList.add('on');
            }
          }
        };
      }(id, settings.options);
    } else {
      optionToggler.classList.add('disabled');
    }
    li.appendChild(optionHeader);

    // -- -- -- create list item text
    var optionP = document.createElement('p');
    var optionText = document.createTextNode(settings.options[i].text);
    optionP.appendChild(optionText);
    li.appendChild(optionP);

    // -- -- -- create additional info div
    var propertiesDiv = document.createElement('div');
    propertiesDiv.classList.add('properties-table', 'm-t-half-space');

    // -- -- -- -- create list item expand button
    var expandPropertiesButton = document.createElement('a');
    expandPropertiesButton.classList.add('btn');
    var expandPropertiesButtonLabel = document.createTextNode(settings.options[i].expandButtonLabel);
    expandPropertiesButton.appendChild(expandPropertiesButtonLabel);
    propertiesDiv.appendChild(expandPropertiesButton);
    expandPropertiesButton.onclick = function (e) {
      toggleElement(e.target.parentNode);
    };

    // -- -- -- -- -- create list item expand button svg
    var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg'); //Get svg element
    svg.classList.add('icon', 'icon-coookie-down');
    svg.setAttribute('viewBox', '0 0 20 20');
    var path = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
    path.setAttribute("d", "M9.293 12.95l0.707 0.707 5.657-5.657-1.414-1.414-4.243 4.242-4.243-4.242-1.414 1.414z"); //Set path's data
    svg.appendChild(path);
    expandPropertiesButton.appendChild(svg);

    // -- -- -- -- create list item expand box div
    var expandTableDiv = document.createElement('div');
    expandTableDiv.classList.add('content');

    // -- -- -- -- -- create list item info table
    var expandTable = document.createElement('table');

    // -- -- -- -- -- -- create list item info th rows
    var expandTableRow = document.createElement('tr');

    // -- -- -- -- -- -- -- create list item info th row columns
    var expandTableThName = document.createElement('th');
    var expandTableName = document.createTextNode(settings.options[i].expandTableNameLabel);
    expandTableThName.appendChild(expandTableName);
    var expandTableThDescription = document.createElement('th');
    var expandTableDescription = document.createTextNode(settings.options[i].expandTableDescriptionLabel);
    expandTableThDescription.appendChild(expandTableDescription);
    expandTableRow.appendChild(expandTableThName);
    expandTableRow.appendChild(expandTableThDescription);
    expandTable.appendChild(expandTableRow);

    // -- -- -- -- -- -- create table rows property info
    var properties = settings.options[i].properties;
    for (var p = 0; p < properties.length; p++) {
      expandTableRow = document.createElement('tr');
      // -- -- -- -- -- -- -- create list item info row columns
      var expandTableNameColumn = document.createElement('td');
      expandTableName = document.createTextNode(properties[p].name);
      expandTableNameColumn.appendChild(expandTableName);
      var expandTableDescriptionColumn = document.createElement('td');
      expandTableDescription = document.createTextNode(properties[p].description);
      expandTableDescriptionColumn.appendChild(expandTableDescription);
      expandTableRow.appendChild(expandTableNameColumn);
      expandTableRow.appendChild(expandTableDescriptionColumn);
      expandTable.appendChild(expandTableRow);
    }
    expandTableDiv.appendChild(expandTable);
    propertiesDiv.appendChild(expandTableDiv);
    li.appendChild(propertiesDiv);
  }
  settingsHolderDiv.appendChild(optionsUl);
  settingsHolderDiv.appendChild(settingsCloseButton);
  settingsDiv.appendChild(settingsHolderDiv);
  cookieOverlay.appendChild(settingsDiv);

  // add overlay to body
  document.body.appendChild(cookieOverlay);
}

// close bar and accept current settings
function acceptCookies(options) {
  if (cookieBar !== undefined) {
    cookieBar.classList.remove('open');
  }
  cookieOverlay.classList.remove('open');
  // setCookies(options);

  // get the current cookies stored in the settings cookie
  var cookies_stored = JSON.parse(getCookie('user_cookies'));
  // console.log(cookies_stored);

  // loop through the options
  for (var i = 0; i < options.length; i++) {
    // check if cookies category can be switched, if not ignore
    if (options[i].switch == true) {
      // check if option is switched on or off
      var properties = cookies_stored[i].properties;
      if (options[i].active) {
        for (var n = 0; n < properties.length; n++) {
          setCookie(properties[n].name, properties[n].value, properties[n].days_stored);
        }
        cookies_stored[i].active = true;
      } else {
        for (var n = 0; n < properties.length; n++) {
          document.cookie = properties[n].name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
        cookies_stored[i].active = false;
      }
      setCookie('user_cookies', JSON.stringify(cookies_stored), 365);
    }
  }
  setCookie('cookie_choices_set', true, 365);
  location.reload();
}

// just close it, it will reopen
function closeCookieBar() {
  cookieBar.classList.remove('open');
}

// open the preferences please
function openPreferences() {
  if (cookieBar !== undefined) {
    cookieBar.classList.remove('open');
  }
  cookieOverlay.classList.add('open');
}

// just close it, it will reopen
function closePreferences(options) {
  cookieOverlay.classList.remove('open');
}

// generic toggle function
function toggleElement(element) {
  if (element.classList.contains('open')) {
    element.classList.remove('open');
  } else {
    element.classList.add('open');
  }
}

// toggleOption
function toggleOption(id, options) {
  if (options[id].active == true) {
    options[id].active = false;
  } else {
    options[id].active = false;
  }
}
"undefined" != typeof document && function (e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);else try {
    n.innerHTML = t;
  } catch (e) {
    n.innerText = t;
  }
}(document, "#cookie-bar, #cookie-overlay {\n" + "  font-size: 1.6rem;\n" + "  font-family: \"Poppins\", Helvetica, Arial, sans-serif; }\n" + "\n" + "/* Examples\n" + "____________________________________________________________________________________\n" + "You can select the type of media query you want to create: maxMin, min or max.\n" + "Use predefined variables (device sizes) or simple px / em values.\n" + "Keep in mind that the default min and max value is set to 0.\n" + "Tip!\n" + "You can do something like @include bp( max, $desktop - 1px ) to apply the styling to screensize below the desktop.\n" + "____________________________________________________________________________________\n" + "---> SCSS to CSS: <----\n" + "@include bp( maxMin, $desktop, 600px ) =\n" + "@media only screen and ( max-width: 1280px ) and ( min-width: 600px ){\n" + "    content\n" + "}\n" + "____________________________________________________________________________________\n" + "@include bp( min, $phone ) =\n" + "@media only screen and (min-width: 480px ){\n" + "    content\n" + "}\n" + "____________________________________________________________________________________\n" + "@include bp( max, 800px ) =\n" + "@media only screen and ( max-width: 800px ){\n" + "    content\n" + "}\n" + "*/\n" + "#cookie-bar, #cookie-overlay {\n" + "  /*\n" + "This .scss loop will create \"margin helpers\" and \"padding helpers\" for use in your web projects.\n" + "It is aimed at keeping a constant vertical rythm in your theme\n" + "It will generate several classes such as:\n" + ".m-r-space which gives margin-right of base amount.\n" + ".m-t-space gives MARGIN to the TOP base amount and so on.\n" + ".p-b-space gives PADDING to the BOTTOM of the base amount\n" + ".p-l-space gives PADDING to the LEFT of the base amount\n" + "The first letter is \"m\" or \"p\" for MARGIN or PADDING\n" + "Second letter is \"t\", \"b\", \"l\", or \"r\" for TOP, BOTTOM, LEFT, or RIGHT\n" + "Third is the base amount, this can alse be prefixed with half- or quarter to give a diffent amount.\n" + "These amounts can also be adjusted responsively, on smaller screen sizes it generally works better to move these closer to each other\n" + "*/ }\n" + "  #cookie-bar *,\n" + "  #cookie-bar *:before,\n" + "  #cookie-bar *:after, #cookie-overlay *,\n" + "  #cookie-overlay *:before,\n" + "  #cookie-overlay *:after {\n" + "    margin: 0;\n" + "    padding: 0;\n" + "    -webkit-box-sizing: border-box;\n" + "    box-sizing: border-box; }\n" + "  #cookie-bar body, #cookie-overlay body {\n" + "    line-height: 1.4em;\n" + "    font-weight: 400;\n" + "    position: relative;\n" + "    overflow-x: hidden; }\n" + "  #cookie-bar ol, #cookie-bar ul, #cookie-overlay ol, #cookie-overlay ul {\n" + "    list-style: none; }\n" + "  #cookie-bar h1,\n" + "  #cookie-bar h2,\n" + "  #cookie-bar h3,\n" + "  #cookie-bar h4,\n" + "  #cookie-bar h5,\n" + "  #cookie-bar h6, #cookie-overlay h1,\n" + "  #cookie-overlay h2,\n" + "  #cookie-overlay h3,\n" + "  #cookie-overlay h4,\n" + "  #cookie-overlay h5,\n" + "  #cookie-overlay h6 {\n" + "    font-size: 100%; }\n" + "  #cookie-bar a, #cookie-overlay a {\n" + "    text-decoration: none; }\n" + "    #cookie-bar a:visited, #cookie-overlay a:visited {\n" + "      color: inherit; }\n" + "    #cookie-bar a:hover, #cookie-bar a:focus, #cookie-overlay a:hover, #cookie-overlay a:focus {\n" + "      color: #0432D7; }\n" + "  #cookie-bar img,\n" + "  #cookie-bar embed,\n" + "  #cookie-bar object,\n" + "  #cookie-bar audio,\n" + "  #cookie-bar video, #cookie-overlay img,\n" + "  #cookie-overlay embed,\n" + "  #cookie-overlay object,\n" + "  #cookie-overlay audio,\n" + "  #cookie-overlay video {\n" + "    max-width: 100%; }\n" + "  #cookie-bar iframe, #cookie-overlay iframe {\n" + "    border: 0; }\n" + "  #cookie-bar table, #cookie-overlay table {\n" + "    border-collapse: collapse;\n" + "    border-spacing: 0; }\n" + "  #cookie-bar td,\n" + "  #cookie-bar th, #cookie-overlay td,\n" + "  #cookie-overlay th {\n" + "    padding: 0;\n" + "    text-align: left; }\n" + "  #cookie-bar .m-t-space, #cookie-overlay .m-t-space {\n" + "    margin-top: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.m-t-space, #cookie-overlay.m-t-space {\n" + "    margin-top: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .p-t-space, #cookie-overlay .p-t-space {\n" + "    padding-top: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.p-t-space, #cookie-overlay.p-t-space {\n" + "    padding-top: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .m-b-space, #cookie-overlay .m-b-space {\n" + "    margin-bottom: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.m-b-space, #cookie-overlay.m-b-space {\n" + "    margin-bottom: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .p-b-space, #cookie-overlay .p-b-space {\n" + "    padding-bottom: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.p-b-space, #cookie-overlay.p-b-space {\n" + "    padding-bottom: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .m-l-space, #cookie-overlay .m-l-space {\n" + "    margin-left: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.m-l-space, #cookie-overlay.m-l-space {\n" + "    margin-left: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .p-l-space, #cookie-overlay .p-l-space {\n" + "    padding-left: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.p-l-space, #cookie-overlay.p-l-space {\n" + "    padding-left: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .m-r-space, #cookie-overlay .m-r-space {\n" + "    margin-right: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.m-r-space, #cookie-overlay.m-r-space {\n" + "    margin-right: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .p-r-space, #cookie-overlay .p-r-space {\n" + "    padding-right: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.p-r-space, #cookie-overlay.p-r-space {\n" + "    padding-right: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .m-all-space, #cookie-overlay .m-all-space {\n" + "    margin: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.m-all-space, #cookie-overlay.m-all-space {\n" + "    margin: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .p-all-space, #cookie-overlay .p-all-space {\n" + "    padding: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar.p-all-space, #cookie-overlay.p-all-space {\n" + "    padding: calc(2vw + 2vh + 2rem) !important; }\n" + "  #cookie-bar .m-t-half-space, #cookie-overlay .m-t-half-space {\n" + "    margin-top: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.m-t-half-space, #cookie-overlay.m-t-half-space {\n" + "    margin-top: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .p-t-half-space, #cookie-overlay .p-t-half-space {\n" + "    padding-top: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.p-t-half-space, #cookie-overlay.p-t-half-space {\n" + "    padding-top: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .m-b-half-space, #cookie-overlay .m-b-half-space {\n" + "    margin-bottom: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.m-b-half-space, #cookie-overlay.m-b-half-space {\n" + "    margin-bottom: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .p-b-half-space, #cookie-overlay .p-b-half-space {\n" + "    padding-bottom: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.p-b-half-space, #cookie-overlay.p-b-half-space {\n" + "    padding-bottom: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .m-l-half-space, #cookie-overlay .m-l-half-space {\n" + "    margin-left: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.m-l-half-space, #cookie-overlay.m-l-half-space {\n" + "    margin-left: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .p-l-half-space, #cookie-overlay .p-l-half-space {\n" + "    padding-left: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.p-l-half-space, #cookie-overlay.p-l-half-space {\n" + "    padding-left: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .m-r-half-space, #cookie-overlay .m-r-half-space {\n" + "    margin-right: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.m-r-half-space, #cookie-overlay.m-r-half-space {\n" + "    margin-right: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .p-r-half-space, #cookie-overlay .p-r-half-space {\n" + "    padding-right: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.p-r-half-space, #cookie-overlay.p-r-half-space {\n" + "    padding-right: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .m-all-half-space, #cookie-overlay .m-all-half-space {\n" + "    margin: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.m-all-half-space, #cookie-overlay.m-all-half-space {\n" + "    margin: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .p-all-half-space, #cookie-overlay .p-all-half-space {\n" + "    padding: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar.p-all-half-space, #cookie-overlay.p-all-half-space {\n" + "    padding: calc(1vw + 1vh + 1rem) !important; }\n" + "  #cookie-bar .m-t-quarter-space, #cookie-overlay .m-t-quarter-space {\n" + "    margin-top: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.m-t-quarter-space, #cookie-overlay.m-t-quarter-space {\n" + "    margin-top: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .p-t-quarter-space, #cookie-overlay .p-t-quarter-space {\n" + "    padding-top: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.p-t-quarter-space, #cookie-overlay.p-t-quarter-space {\n" + "    padding-top: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .m-b-quarter-space, #cookie-overlay .m-b-quarter-space {\n" + "    margin-bottom: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.m-b-quarter-space, #cookie-overlay.m-b-quarter-space {\n" + "    margin-bottom: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .p-b-quarter-space, #cookie-overlay .p-b-quarter-space {\n" + "    padding-bottom: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.p-b-quarter-space, #cookie-overlay.p-b-quarter-space {\n" + "    padding-bottom: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .m-l-quarter-space, #cookie-overlay .m-l-quarter-space {\n" + "    margin-left: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.m-l-quarter-space, #cookie-overlay.m-l-quarter-space {\n" + "    margin-left: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .p-l-quarter-space, #cookie-overlay .p-l-quarter-space {\n" + "    padding-left: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.p-l-quarter-space, #cookie-overlay.p-l-quarter-space {\n" + "    padding-left: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .m-r-quarter-space, #cookie-overlay .m-r-quarter-space {\n" + "    margin-right: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.m-r-quarter-space, #cookie-overlay.m-r-quarter-space {\n" + "    margin-right: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .p-r-quarter-space, #cookie-overlay .p-r-quarter-space {\n" + "    padding-right: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.p-r-quarter-space, #cookie-overlay.p-r-quarter-space {\n" + "    padding-right: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .m-all-quarter-space, #cookie-overlay .m-all-quarter-space {\n" + "    margin: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.m-all-quarter-space, #cookie-overlay.m-all-quarter-space {\n" + "    margin: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .p-all-quarter-space, #cookie-overlay .p-all-quarter-space {\n" + "    padding: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar.p-all-quarter-space, #cookie-overlay.p-all-quarter-space {\n" + "    padding: calc(0.5vw + 0.5vh + 0.5rem) !important; }\n" + "  #cookie-bar .m-t-double-space, #cookie-overlay .m-t-double-space {\n" + "    margin-top: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.m-t-double-space, #cookie-overlay.m-t-double-space {\n" + "    margin-top: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .p-t-double-space, #cookie-overlay .p-t-double-space {\n" + "    padding-top: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.p-t-double-space, #cookie-overlay.p-t-double-space {\n" + "    padding-top: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .m-b-double-space, #cookie-overlay .m-b-double-space {\n" + "    margin-bottom: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.m-b-double-space, #cookie-overlay.m-b-double-space {\n" + "    margin-bottom: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .p-b-double-space, #cookie-overlay .p-b-double-space {\n" + "    padding-bottom: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.p-b-double-space, #cookie-overlay.p-b-double-space {\n" + "    padding-bottom: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .m-l-double-space, #cookie-overlay .m-l-double-space {\n" + "    margin-left: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.m-l-double-space, #cookie-overlay.m-l-double-space {\n" + "    margin-left: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .p-l-double-space, #cookie-overlay .p-l-double-space {\n" + "    padding-left: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.p-l-double-space, #cookie-overlay.p-l-double-space {\n" + "    padding-left: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .m-r-double-space, #cookie-overlay .m-r-double-space {\n" + "    margin-right: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.m-r-double-space, #cookie-overlay.m-r-double-space {\n" + "    margin-right: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .p-r-double-space, #cookie-overlay .p-r-double-space {\n" + "    padding-right: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.p-r-double-space, #cookie-overlay.p-r-double-space {\n" + "    padding-right: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .m-all-double-space, #cookie-overlay .m-all-double-space {\n" + "    margin: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.m-all-double-space, #cookie-overlay.m-all-double-space {\n" + "    margin: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .p-all-double-space, #cookie-overlay .p-all-double-space {\n" + "    padding: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar.p-all-double-space, #cookie-overlay.p-all-double-space {\n" + "    padding: calc(4vw + 4vh + 4rem) !important; }\n" + "  #cookie-bar .align-center, #cookie-overlay .align-center {\n" + "    text-align: center; }\n" + "  #cookie-bar .push-right, #cookie-overlay .push-right {\n" + "    -ms-flex-line-pack: end;\n" + "    align-content: flex-end; }\n" + "\n" + "#cookie-bar a, #cookie-overlay a {\n" + "  text-decoration: underline;\n" + "  -webkit-transition: all 0.1s;\n" + "  /* Safari */\n" + "  -o-transition: all 0.1s;\n" + "  transition: all 0.1s;\n" + "  color: #000; }\n" + "  #cookie-bar a:hover, #cookie-overlay a:hover {\n" + "    filter: alpha(opacity=100);\n" + "    cursor: pointer;\n" + "    color: inherit; }\n" + "  #cookie-bar a.tel, #cookie-overlay a.tel {\n" + "    text-decoration: none; }\n" + "\n" + "#cookie-bar .btn,\n" + "#cookie-bar button, #cookie-overlay .btn,\n" + "#cookie-overlay button {\n" + "  display: inline-block;\n" + "  background-color: transparent;\n" + "  padding: 8px 15px;\n" + "  text-decoration: none;\n" + "  font-weight: 400;\n" + "  outline: none;\n" + "  border: none;\n" + "  -webkit-transition: 200ms ease-in-out;\n" + "  -o-transition: 200ms ease-in-out;\n" + "  transition: 200ms ease-in-out;\n" + "  font-size: 1.5rem;\n" + "  text-align: center;\n" + "  border: 2px solid #0A3DFA;\n" + "  -webkit-border-radius: 0px;\n" + "  border-radius: 0px;\n" + "  color: #0A3DFA; }\n" + "  #cookie-bar .btn:hover, #cookie-bar .btn:focus,\n" + "  #cookie-bar button:hover, #cookie-bar button:focus, #cookie-overlay .btn:hover, #cookie-overlay .btn:focus,\n" + "  #cookie-overlay button:hover, #cookie-overlay button:focus {\n" + "    background-color: #0A3DFA;\n" + "    color: white; }\n" + "\n" + "#cookie-bar a.btn-highlight, #cookie-bar button.btn-highlight,\n" + "#cookie-bar .btn-highlight, #cookie-overlay a.btn-highlight, #cookie-overlay button.btn-highlight,\n" + "#cookie-overlay .btn-highlight {\n" + "  background-color: #0A3DFA;\n" + "  color: white; }\n" + "  #cookie-bar a.btn-highlight:focus,\n" + "  #cookie-bar button.btn-highlight:focus,\n" + "  #cookie-bar a.btn-highlight:hover,\n" + "  #cookie-bar button.btn-highlight:hover,\n" + "  #cookie-bar .btn-highlight:hover, #cookie-overlay a.btn-highlight:hover,\n" + "  #cookie-overlay .btn-highlight:hover, #cookie-overlay .btn-highlight:focus {\n" + "    background-color: white;\n" + "    color: #0A3DFA; }\n" + "\n" + "#cookie-bar #cookie-bar, #cookie-bar #cookie-overlay, #cookie-bar, #cookie-overlay #cookie-bar, #cookie-overlay #cookie-overlay, #cookie-overlay {\n" + "  font-size: 1.6rem;\n" + "  line-height: 1.4em; }\n" + "\n" + "#cookie-bar p + .btn,\n" + "#cookie-bar p + p, #cookie-overlay p + .btn,\n" + "#cookie-overlay p + p {\n" + "  margin-top: 1.5rem; }\n" + "\n" + "#cookie-bar h1, #cookie-bar h2, #cookie-bar p, #cookie-bar small, #cookie-bar ul li, #cookie-overlay h1, #cookie-overlay h2, #cookie-overlay p, #cookie-overlay small, #cookie-overlay ul li {\n" + "  color: #2e2e2e; }\n" + "\n" + "#cookie-bar h1, #cookie-bar h2, #cookie-bar h3, #cookie-overlay h1, #cookie-overlay h2, #cookie-overlay h3 {\n" + "  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n" + "  font-weight: 400;\n" + "  line-height: 1.2em; }\n" + "\n" + "#cookie-bar {\n" + "  position: fixed;\n" + "  background-color: white;\n" + "  border-top: 2px solid #0A3DFA;\n" + "  width: 100%;\n" + "  bottom: 0;\n" + "  left: 0;\n" + "  -webkit-box-sizing: border-box;\n" + "  box-sizing: border-box;\n" + "  opacity: 0;\n" + "  -webkit-transition: .7s ease-in-out;\n" + "  -o-transition: .7s ease-in-out;\n" + "  transition: .7s ease-in-out;\n" + "  -webkit-transform: translateY(200px);\n" + "  -ms-transform: translateY(200px);\n" + "  transform: translateY(200px);\n" + "  z-index: 5; }\n" + "  #cookie-bar::after {\n" + "    display: block;\n" + "    content: \"\";\n" + "    clear: both; }\n" + "  @media only screen and (max-width: 37.5em) {\n" + "    #cookie-bar {\n" + "      padding: calc(.75vw + .75vh + .75rem); } }\n" + "  #cookie-bar.open {\n" + "    -webkit-transform: translateY(0);\n" + "    -ms-transform: translateY(0);\n" + "    transform: translateY(0);\n" + "    opacity: 1; }\n" + "  #cookie-bar .text {\n" + "    float: left;\n" + "    width: calc(100% - 500px); }\n" + "    @media only screen and (max-width: 60em) {\n" + "      #cookie-bar .text {\n" + "        width: calc(100% - 5rem);\n" + "        margin-bottom: 1rem; } }\n" + "    @media only screen and (max-width: 37.5em) {\n" + "      #cookie-bar .text p {\n" + "        display: none; } }\n" + "  #cookie-bar h2 {\n" + "    font-size: 1.1em;\n" + "    font-weight: 500;\n" + "    margin: 0; }\n" + "    @media only screen and (max-width: 37.5em) {\n" + "      #cookie-bar h2 {\n" + "        font-size: 1.6rem; } }\n" + "  #cookie-bar h2 + p {\n" + "    margin-top: .5rem; }\n" + "  #cookie-bar .icon {\n" + "    float: left;\n" + "    width: 30px;\n" + "    height: 30px;\n" + "    margin-right: 1.5rem;\n" + "    margin-top: 4px;\n" + "    cursor: pointer;\n" + "    fill: #0A3DFA; }\n" + "    #cookie-bar .icon:hover {\n" + "      -webkit-animation: rotate 2.5s linear infinite;\n" + "      animation: rotate 2.5s linear infinite; }\n" + "  #cookie-bar .actions {\n" + "    float: right; }\n" + "    @media only screen and (max-width: 37.5em) {\n" + "      #cookie-bar .actions {\n" + "        float: left; } }\n" + "    #cookie-bar .actions .btn {\n" + "      margin-left: 5px; }\n" + "      @media only screen and (max-width: 37.5em) {\n" + "        #cookie-bar .actions .btn {\n" + "          font-size: 1.3rem;\n" + "          margin-left: 3px;\n" + "          padding: 5px 8px; } }\n" + "  #cookie-bar p {\n" + "    margin: 0;\n" + "    font-size: .9em; }\n" + "  #cookie-bar .cookie-close-button {\n" + "    background-color: transparent;\n" + "    border: 0px transparent;\n" + "    position: relative;\n" + "    width: 20px;\n" + "    height: 20px;\n" + "    display: inline-block;\n" + "    margin-left: 10px;\n" + "    vertical-align: middle; }\n" + "  #cookie-bar .cookie-close-button:hover, #cookie-bar .cookie-close-button:focus {\n" + "    background-color: transparent; }\n" + "  #cookie-bar .cookie-close-button:hover div, #cookie-bar .cookie-close-button:focus div {\n" + "    background-color: black; }\n" + "    @media only screen and (max-width: 37.5em) {\n" + "      #cookie-bar .cookie-close-button {\n" + "        margin-left: 5px; } }\n" + "\n" + "@-webkit-keyframes rotate {\n" + "  to {\n" + "    -webkit-transform: rotate(360deg);\n" + "    transform: rotate(360deg); } }\n" + "\n" + "@keyframes rotate {\n" + "  to {\n" + "    -webkit-transform: rotate(360deg);\n" + "    transform: rotate(360deg); } }\n" + "\n" + "#cookie-overlay {\n" + "  position: fixed;\n" + "  left: 0;\n" + "  top: 0;\n" + "  width: 100vw;\n" + "  height: 100vh;\n" + "  background-color: rgba(0, 0, 0, 0.4);\n" + "  z-index: 0;\n" + "  pointer-events: none;\n" + "  opacity: 0;\n" + "  -webkit-transition: .4s ease-in-out;\n" + "  -o-transition: .4s ease-in-out;\n" + "  transition: .4s ease-in-out; }\n" + "  #cookie-overlay.open {\n" + "    opacity: 1;\n" + "    pointer-events: all;\n" + "    z-index: 9999; }\n" + "    #cookie-overlay.open .cookie-settings {\n" + "      opacity: 1;\n" + "      -webkit-transform: translateX(0);\n" + "      -ms-transform: translateX(0);\n" + "      transform: translateX(0); }\n" + "  #cookie-overlay .cookie-settings {\n" + "    position: fixed;\n" + "    width: 500px;\n" + "    height: 100vh;\n" + "    background-color: white;\n" + "    -webkit-box-sizing: border-box;\n" + "    box-sizing: border-box;\n" + "    overflow-y: auto;\n" + "    opacity: 0;\n" + "    -webkit-transition: .6s ease-in-out;\n" + "    -o-transition: .6s ease-in-out;\n" + "    transition: .6s ease-in-out;\n" + "    -webkit-transform: translateX(-500px);\n" + "    -ms-transform: translateX(-500px);\n" + "    transform: translateX(-500px);\n" + "    font-size: 1rem; }\n" + "    @media only screen and (max-width: 37.5em) {\n" + "      #cookie-overlay .cookie-settings {\n" + "        width: 100%; } }\n" + "    #cookie-overlay .cookie-settings .settings-holder {\n" + "      width: 100%;\n" + "      position: relative;\n" + "      height: auto; }\n" + "    #cookie-overlay .cookie-settings .cookie-close-button {\n" + "      position: absolute;\n" + "      right: 20px;\n" + "      top: 20px; }\n" + "    #cookie-overlay .cookie-settings h2 {\n" + "      font-size: 2em;\n" + "      margin-bottom: 1rem;\n" + "      font-weight: 500; }\n" + "    #cookie-overlay .cookie-settings h3 {\n" + "      margin-bottom: .5rem;\n" + "      font-weight: 500; }\n" + "    #cookie-overlay .cookie-settings p {\n" + "      line-height: 1.6em; }\n" + "    #cookie-overlay .cookie-settings ul li {\n" + "      margin-top: -1px;\n" + "      border-top: 1px solid #bfbfbf;\n" + "      border-bottom: 1px solid #bfbfbf;\n" + "      line-height: 1.4rem; }\n" + "      #cookie-overlay .cookie-settings ul li header {\n" + "        padding-right: 100px;\n" + "        padding-top: 10px;\n" + "        padding-bottom: 10px;\n" + "        position: relative; }\n" + "        #cookie-overlay .cookie-settings ul li header h3 {\n" + "          margin-bottom: 0;\n" + "          font-size: 1.75rem; }\n" + "        #cookie-overlay .cookie-settings ul li header .switch {\n" + "          cursor: pointer;\n" + "          font-size: 1.5em;\n" + "          line-height: 1.1em;\n" + "          position: absolute;\n" + "          right: 0;\n" + "          top: 5px;\n" + "          display: block;\n" + "          width: 70px;\n" + "          height: 30px;\n" + "          background-color: #0A3DFA;\n" + "          -webkit-border-radius: 15px;\n" + "          border-radius: 15px;\n" + "          color: white;\n" + "          text-decoration: none;\n" + "          padding: 6px 10px; }\n" + "          #cookie-overlay .cookie-settings ul li header .switch.on:after {\n" + "            right: 3px; }\n" + "          #cookie-overlay .cookie-settings ul li header .switch.disabled {\n" + "            opacity: .25;\n" + "            pointer-events: none; }\n" + "          #cookie-overlay .cookie-settings ul li header .switch:before, #cookie-overlay .cookie-settings ul li header .switch:after {\n" + "            position: absolute; }\n" + "          #cookie-overlay .cookie-settings ul li header .switch:after {\n" + "            content: '';\n" + "            right: 34px;\n" + "            top: 3px;\n" + "            width: 32px;\n" + "            height: 24px;\n" + "            background: white;\n" + "            -webkit-border-radius: 12px;\n" + "            border-radius: 12px;\n" + "            -webkit-transition: .25s ease-in-out;\n" + "            -o-transition: .25s ease-in-out;\n" + "            transition: .25s ease-in-out; }\n" + "          #cookie-overlay .cookie-settings ul li header .switch:before {\n" + "            content: 'off';\n" + "            right: 10px;\n" + "            top: 6px;\n" + "            opacity: .35;\n" + "            color: white; }\n" + "    #cookie-overlay .cookie-settings .properties-table a.btn {\n" + "      font-size: 1.4em;\n" + "      line-height: 1.6rem;\n" + "      text-align: left;\n" + "      padding-left: 40px;\n" + "      position: relative;\n" + "      padding-top: 12px;\n" + "      padding-bottom: 12px; }\n" + "      #cookie-overlay .cookie-settings .properties-table a.btn:hover .icon {\n" + "        fill: white; }\n" + "      #cookie-overlay .cookie-settings .properties-table a.btn .icon {\n" + "        -webkit-transition: 150ms;\n" + "        -o-transition: 150ms;\n" + "        transition: 150ms;\n" + "        position: absolute;\n" + "        width: 20px;\n" + "        height: 20px;\n" + "        left: 10px;\n" + "        top: 10px;\n" + "        fill: #0A3DFA;\n" + "        -webkit-transform: rotate(0deg);\n" + "        -ms-transform: rotate(0deg);\n" + "        transform: rotate(0deg); }\n" + "    #cookie-overlay .cookie-settings .properties-table .content {\n" + "      max-height: 0;\n" + "      overflow: hidden;\n" + "      -webkit-transition: .6s ease-in-out;\n" + "      -o-transition: .6s ease-in-out;\n" + "      transition: .6s ease-in-out; }\n" + "    #cookie-overlay .cookie-settings .properties-table table {\n" + "      margin-top: 10px;\n" + "      border: 2px solid #000;\n" + "      width: 100%; }\n" + "      #cookie-overlay .cookie-settings .properties-table table td, #cookie-overlay .cookie-settings .properties-table table th {\n" + "        padding: 10px;\n" + "        border-left: 1px solid rgba(0, 0, 0, 0.2);\n" + "        border-right: 1px solid rgba(0, 0, 0, 0.2);\n" + "        border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n" + "        vertical-align: top;\n" + "        font-size: 1.1em;\n" + "        line-height: 1.6em; }\n" + "    #cookie-overlay .cookie-settings .properties-table.open .content {\n" + "      max-height: 1999px; }\n" + "    #cookie-overlay .cookie-settings .properties-table.open a.btn {\n" + "      background-color: #0A3DFA;\n" + "      color: white; }\n" + "      #cookie-overlay .cookie-settings .properties-table.open a.btn .icon {\n" + "        fill: white;\n" + "        -webkit-transform: rotate(180deg);\n" + "        -ms-transform: rotate(180deg);\n" + "        transform: rotate(180deg); }\n" + "\n" + ".cookie-close-button {\n" + "  width: 20px;\n" + "  height: 20px;\n" + "  cursor: pointer;\n" + "  -webkit-transition: 300ms ease-in-out;\n" + "  -o-transition: 300ms ease-in-out;\n" + "  transition: 300ms ease-in-out; }\n" + "  .cookie-close-button:hover {\n" + "    -webkit-transform: scale3d(1.05, 1.05, 1.05);\n" + "    transform: scale3d(1.05, 1.05, 1.05); }\n" + "  .cookie-close-button .bar {\n" + "    position: absolute;\n" + "    width: 100%;\n" + "    height: 3px;\n" + "    background-color: #0A3DFA;\n" + "    left: 0;\n" + "    top: 50%;\n" + "    -webkit-transform: translateY(-50%) rotate(45deg);\n" + "    -ms-transform: translateY(-50%) rotate(45deg);\n" + "    transform: translateY(-50%) rotate(45deg); }\n" + "    .cookie-close-button .bar:last-child {\n" + "      -webkit-transform: translateY(-50%) rotate(-45deg);\n" + "      -ms-transform: translateY(-50%) rotate(-45deg);\n" + "      transform: translateY(-50%) rotate(-45deg); }");
/* 
    This is your main JS file (frontend). Don't rename it. You can split up your script into sepperate files inside the src/javascript/scripts/ folder.
    Vendors will be bundled and prepended before all of your own javascript. Stick your vendor js files inside the src/javascript/vendor/ folder.
    Make sure to declare all the vendors and custom scripts inside the projectConfig.js file.
*/
document.addEventListener('DOMContentLoaded', function () {
  // let hero = document.getElementsByClassName("hero")[0];
  let header = document.getElementsByClassName("site-header")[0];
  let hero = document.getElementsByClassName("c-hero")[0];
  let desktopmenu = header.getElementsByClassName('desktop-menu')[0];
  let mobilemenu = document.getElementsByClassName('mobile-menu')[0];
  let subTogglers = header.getElementsByClassName('sub-toggler');
  let menuToggler = header.getElementsByClassName("menu-toggler")[0];
  let searchToggler = header.getElementsByClassName("search-toggler")[0];
  let searchLabel = searchToggler.getElementsByClassName("label")[0];
  let searchForm = document.getElementById("desktopSearchForm");
  let searchInput = searchForm.getElementsByClassName("search-input")[0];
  let svgRects = document.getElementsByClassName("svgrect");
  let svgInitials = document.getElementsByClassName("svgInitial");
  let arrowDown = document.querySelector('.arrow-down');
  let headerObj = {
    $el: header,
    $hero: hero,
    locked: false,
    scroll: 0,
    clearAmount: 0,
    isFixed: false,
    continueDown: true,
    continueUp: false,
    lockedOn: 0
  };

  // get only first level children
  function getChildNodes(node) {
    var children = new Array();
    for (let i = 0; i < node.childNodes.length; i++) {
      if (node.childNodes[i].nodeType == 1) {
        children.push(node.childNodes[i]);
      }
    }
    return children;
  }

  // Create main desktop navigation logic
  function desktopMenuListeners() {
    var $listItems = getChildNodes(desktopmenu);
    createFocusListeners($listItems);
  }
  desktopMenuListeners();

  // Create main mobile navigation logic
  function mobileMenuListeners() {
    var $listItems = getChildNodes(mobilemenu);
    createFocusListeners($listItems);
  }
  mobileMenuListeners();
  function createFocusListeners($listItems) {
    // add a focus listener on the members with a sub menu
    for (let i = 0; i < $listItems.length; i++) {
      var $li = $listItems[i];
      var anchor = $li.querySelector('a');
      if ($li.classList.contains('has-sub')) {
        anchor.addEventListener('focus', function (event) {
          $listItems[i].classList.add('has-focus');
        });
      } else {
        anchor.addEventListener('focus', function (event) {
          for (let n = 0; n < $listItems.length; n++) {
            $listItems[n].classList.remove('has-focus');
          }
        });
      }
    }
    // add focusout to the submenu to make the submenus disappear 
    // when moving anywhere outside of the header
    header.addEventListener('mouseout', function (event) {
      for (let i = 0; i < $listItems.length; i++) {
        $listItems[i].classList.remove('has-focus');
      }
    });
  }
  function initMenu() {
    menuToggler.onclick = function (e) {
      if (document.body.classList.contains('menu-open')) {
        document.body.classList.remove('animate-menu');
        document.body.classList.remove('menu-open');
        // When the modal is shown, we want a fixed body
        let scrollY = document.body.style.top;
        document.body.style.top = '';
        document.body.style.position = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        menuToggler.setAttribute("aria-expanded", "false");
      } else {
        document.body.classList.add('animate-menu');
        setTimeout(() => {
          document.body.classList.add('menu-open');
          // When the modal is shown, we want a fixed body
          document.body.style.top = '-' + window.scrollY + 'px';
          document.body.style.position = 'fixed';
          menuToggler.setAttribute("aria-expanded", "true");
        }, 400);
      }
    };
    searchToggler.onclick = function (e) {
      const expanded = searchToggler.getAttribute('aria-expanded') === 'true' || false;
      const svgUse = searchToggler.querySelector('svg > use');
      searchToggler.setAttribute('aria-expanded', !expanded);
      searchForm.setAttribute('aria-hidden', expanded);
      if (document.body.classList.contains('search-open')) {
        searchForm.classList.remove('show');
        setTimeout(() => {
          svgUse.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-search');
          document.body.classList.remove('search-open');
          searchLabel.innerHTML = 'Zoeken';
        }, 300);
      } else {
        document.body.classList.add('search-open');
        svgUse.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-close');
        searchLabel.innerHTML = 'Sluiten';
        searchInput.focus();
        setTimeout(() => {
          searchForm.classList.add('show');
        }, 100);
      }
    };
    if (subTogglers.length > 0) {
      for (var i = 0; i < subTogglers.length; i++) {
        let subToggler = subTogglers[i];
        let parent = subToggler.parentNode;
        subToggler.onclick = function (event) {
          event.preventDefault();
          if (parent.classList.contains('open')) {
            for (var n = 0; n < subTogglers.length; n++) {
              subTogglers[n].setAttribute("aria-expanded", "false");
            }
            parent.classList.remove('open');
          } else {
            for (var n = 0; n < subTogglers.length; n++) {
              subTogglers[n].setAttribute("aria-expanded", "true");
            }
            parent.classList.add('open');
          }
        };
      }
    }
  }
  initMenu();
  function handleScroll() {
    var hh = headerObj.$el.clientHeight;
    if (window.pageYOffset > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    if (window.pageYOffset > 100) {
      headerObj.locked = false;
    } else {
      headerObj.locked = true;
    }
    if (window.pageYOffset > 10) {
      if (window.pageYOffset > headerObj.scroll) {
        // we go down
        headerObj.clearAmount = headerObj.clearAmount - (window.pageYOffset - headerObj.scroll);
        if (headerObj.clearAmount < 0) {
          headerObj.clearAmount = 0;
        }
        if (headerObj.isFixed == true) {
          if (headerObj.continueDown == false) {
            headerObj.$el.style.position = 'absolute';
            headerObj.$el.style.top = pageYOffset + 'px';
            headerObj.continueUp = true;
            headerObj.isFixed = false;
          }
        }
        headerObj.continueDown = true;
      } else {
        headerObj.clearAmount = headerObj.clearAmount + (headerObj.scroll - window.pageYOffset);
        if (headerObj.clearAmount > hh) {
          headerObj.clearAmount = hh;
        }
        if (headerObj.continueDown == true) {
          headerObj.$el.style.top = pageYOffset - (hh - headerObj.clearAmount) + 'px';
          headerObj.lockedOn = pageYOffset - (hh - headerObj.clearAmount);
          headerObj.continueDown = false;
        } else {
          if (headerObj.isFixed == false) {
            if (pageYOffset < headerObj.lockedOn) {
              headerObj.$el.style.top = 0;
              headerObj.$el.style.position = 'fixed';
              headerObj.isFixed = true;
            }
          }
        }
        headerObj.continueUp = true;
      }
    } else {
      headerObj.$el.style.top = 0 + 'px';
    }
    headerObj.scroll = window.pageYOffset;
  }
  window.addEventListener("scroll", function () {
    handleScroll();
  });
  window.addEventListener("DOMMouseScroll", function () {
    handleScroll();
  });
  setTimeout(function () {
    handleScroll();
  }, 0);

  // item in view listener
  var $inviewitems = document.getElementsByClassName("item-in-view");
  function inviewCB() {}
  ;
  if ($inviewitems.length > 0) {
    for (var i = 0; i < $inviewitems.length; i++) {
      var iv = new Iteminview($inviewitems[i], {
        row: false,
        callback: inviewCB
      });
    }
  }

  // lazy loading
  function loadImage($image) {
    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("load");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });
      lazyImageObserver.observe($image);
    } else {
      // Possibly fall back to a more compatible method here
    }
  }
  ;
  var $loadimages = document.getElementsByClassName("load");
  if ($loadimages.length > 0) {
    for (var i = 0; i < $loadimages.length; i++) {
      loadImage($loadimages[i]);
    }
  }

  // main function
  function scrollToY(scrollTargetY, speed, easing) {
    var scrollY = window.pageYOffset,
      scrollTargetY = scrollTargetY || 0,
      speed = speed || 2000,
      easing = easing || 'easeOutSine',
      currentTime = 0;

    // min time .1, max time .8 seconds
    var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

    // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
    var PI_D2 = Math.PI / 2,
      easingEquations = {
        easeOutSine: function easeOutSine(pos) {
          return Math.sin(pos * (Math.PI / 2));
        },
        easeInOutSine: function easeInOutSine(pos) {
          return -0.5 * (Math.cos(Math.PI * pos) - 1);
        },
        easeInOutQuint: function easeInOutQuint(pos) {
          if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(pos, 5);
          }
          return 0.5 * (Math.pow(pos - 2, 5) + 2);
        }
      };

    // add animation loop
    function tick() {
      currentTime += 1 / 60;
      var p = currentTime / time;
      var t = easingEquations[easing](p);
      if (p < 1) {
        requestAnimFrame(tick);
        window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
      } else {
        window.scrollTo(0, scrollTargetY);
      }
    }

    // call it once to get started
    tick();
  }
  if (arrowDown !== null) {
    arrowDown.onclick = function (e) {
      scrollToY(window.outerHeight, 800, 'easeInOutQuint');
    };
  }
  function SVGButtonsAnimation(svgRects) {
    setTimeout(function () {
      if (svgRects.length !== 0) {
        for (var i = 0; i < svgRects.length; i++) {
          let rect = svgRects[i];
          let w = rect.parentNode.clientWidth;
          let h = rect.parentNode.clientHeight;
          rect.style.strokeDasharray = 2 * w + 2 * h;
          rect.style.strokeDashoffset = 2 * w + 2 * h;
          rect.parentNode.parentNode.onmouseover = function () {
            rect.style.strokeDashoffset = h - 10;
            rect.style.opacity = 1;
          };
          rect.parentNode.parentNode.onmouseout = function () {
            rect.style.strokeDashoffset = 2 * w + 2 * h;
            rect.style.opacity = 0;
          };
        }
      }
    }, 1000);
  }
  SVGButtonsAnimation(svgRects);
  function SVGInitialsAnimation(svgInitials) {
    if (svgInitials.length !== 0) {
      setTimeout(function () {
        for (var i = 0; i < svgInitials.length; i++) {
          let rect = svgInitials[i];
          let w = rect.parentNode.clientWidth;
          let h = rect.parentNode.clientHeight;
          rect.style.strokeDasharray = 2 * w + 2 * h;
          rect.style.strokeDashoffset = 2 * w + 2 * h + 10;
        }
      }, 100);
    }
  }
  SVGInitialsAnimation(svgInitials);
  window.addEventListener("resize", function () {
    SVGButtonsAnimation(svgRects);
  });
});